import { useGame } from "~/app";
import { IntrigueCard } from "~/business";
import { XIntrigueCard, XPackBy } from "~/jsx/components/design";
import { ModalNames } from "~/jsx/context/ModalNames";
import { useActions, useViewingPlayerOpt } from "~/jsx/hook";
import { Sizes } from "~/jsx/theme";
import { useModal } from "~/utils";
import { XDesignModal } from "../design/XDesignModal";

export const XIntrigueModal = () => {
  const { game } = useGame();
  const { onIntrigue } = useActions();
  const viewingPlayer = useViewingPlayerOpt();
  const { hide } = useModal(ModalNames.intrigue);
  if (!viewingPlayer) return null;
  const { intrigueCards } = viewingPlayer;

  const onClick = (card: IntrigueCard) => {
    const isPlayable = !game.validatePlayIntrigue(viewingPlayer.id, card.id);
    return isPlayable
      ? () => {
          hide();
          onIntrigue(card);
        }
      : undefined;
  };

  return (
    <XDesignModal name={ModalNames.intrigue} title="Play an intrigue card">
      <XPackBy packSize={5} gap={5}>
        {intrigueCards.pile.map((card) => (
          <XIntrigueCard
            key={card.id}
            card={card}
            width={Sizes.intrigueCard.width}
            onClick={onClick(card)}
          />
        ))}
      </XPackBy>
    </XDesignModal>
  );
};
